import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { dealOfTheDayService } from "@/services/api/cresivoxServer";
import { iDealOfTheDayDTO, iDealOfTheDayResponse, REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const createDealOfTheDay = createAsyncThunk<
  iGenericResponse<iDealOfTheDayResponse>,
  iDealOfTheDayDTO,
  { rejectValue: iStateMessage }
>(curriedGetThunkName("createDealOfTheDay"),
//@ts-ignore
 async (data, { rejectWithValue }) => {
  try {
    const response = await dealOfTheDayService.createDeal(data);
    if (!response) {
      return rejectWithValue({
        message: "No response received from server",
        httpStatusCode: 500
      });
    }

    if (response.httpStatusCode === httpStatusCodes.SUCCESS_CREATED) {
      return {
        data: response.data,
        message: "Deal created successfully"
      };
    }
    
    return rejectWithValue({
      message: response.error || "Failed to create deal",
      httpStatusCode: response.httpStatusCode
    });
  } catch (error: any) {
    return rejectWithValue({
      message: error.message || "Something went wrong",
      httpStatusCode: error.httpStatusCode || 500
    });
  }
});

export const getAllDeals = createAsyncThunk<
  iGenericResponse<iDealOfTheDayResponse[]>,
  void,
  { rejectValue: iStateMessage }
>(curriedGetThunkName("getAllDeals"),
//@ts-ignore
 async (_, { rejectWithValue }) => {
  try {
    const response = await dealOfTheDayService.getAllDeals();
    if (!response) {
      return rejectWithValue({
        message: "No response received from server",
        httpStatusCode: 500
      });
    }

    if (response.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
      return {
        data: response.data,
        message: "Deals fetched successfully"
      };
    }
    
    return rejectWithValue({
      message: response.error || "Failed to fetch deals",
      httpStatusCode: response.httpStatusCode
    });
  } catch (error: any) {
    return rejectWithValue({
      message: error.message || "Something went wrong",
      httpStatusCode: error.httpStatusCode || 500
    });
  }
});

export const deleteDeal = createAsyncThunk<
  iGenericResponse<{ id: string }>,
  { dealdayId: string },
  { rejectValue: iStateMessage }
>(curriedGetThunkName("deleteDeal"),
//@ts-ignore
 async ({ dealdayId }, { rejectWithValue }) => {
  try {
    const response = await dealOfTheDayService.deleteDeal(dealdayId);
    if (!response) {
      return rejectWithValue({
        message: "No response received from server",
        httpStatusCode: 500
      });
    }

    if (response.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
      return {
        data: { id: dealdayId },
        message: "Deal deleted successfully"
      };
    }
    
    return rejectWithValue({
      message: response.error || "Failed to delete deal",
      httpStatusCode: response.httpStatusCode
    });
  } catch (error: any) {
    return rejectWithValue({
      message: error.message || "Something went wrong",
      httpStatusCode: error.httpStatusCode || 500
    });
  }
});

export const toggleDealStatus = createAsyncThunk<
  iGenericResponse<{ id: string; status: boolean }>,
  { dealdayId: string; status: boolean },
  { rejectValue: iStateMessage }
>(curriedGetThunkName("toggleDealStatus"),
//@ts-ignore
 async ({ dealdayId, status }, { rejectWithValue }) => {
  try {
const response = await dealOfTheDayService.toggleDealStatus(dealdayId, status);

    if (!response) {
      return rejectWithValue({
        message: "No response received from server",
        httpStatusCode: 500
      });
    }

    if (response.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
      return {
        data: { id: dealdayId, status },
        message: "Deal status updated successfully"
      };
    }
    
    return rejectWithValue({
      message: response.error || "Failed to update deal status",
      httpStatusCode: response.httpStatusCode
    });
  } catch (error: any) {
    return rejectWithValue({
      message: error.message || "Something went wrong",
      httpStatusCode: error.httpStatusCode || 500
    });
  }
});